import { getButtonVariantProps } from 'pricing-pages-lib/utils/buttonVariantUtils';
import { PRODUCT_CARD } from '../../../constants/tracking/TrackingSources';
import SingleProductCTA from '../../../features/purchaseMotions/components/SingleProductCTA';
import DisabledDowngradeButton from '../../buttons/DisabledDowngradeButton';
import SignupButton from '../../common/SignupButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductTileCTAs = ({
  apiName,
  screen,
  trackingSource = PRODUCT_CARD,
  skipInterstitialPage = false,
  hasHigherTieredProduct,
  isHubspotFree,
  purchaseMotions,
  location = 'MERCH_CARD'
}) => {
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });
  if (isHubspotFree) {
    return /*#__PURE__*/_jsx(SignupButton, {
      trackingSource: trackingSource,
      sourceId: trackingSource,
      nonMerchandiseIdProduct: apiName
    });
  }
  if (hasHigherTieredProduct) {
    return /*#__PURE__*/_jsx(DisabledDowngradeButton, {});
  }
  return purchaseMotions.map((purchaseMotion, index) => /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(SingleProductCTA, Object.assign({
      use: index === 0 ? 'primary' : 'secondary',
      purchaseMotion: purchaseMotion,
      apiName: apiName,
      screen: screen,
      trackingSource: trackingSource,
      purchaseMotionLocation: location,
      skipInterstitialPage: skipInterstitialPage
    }, ctaVariantProps))
  }, purchaseMotion));
};
export default ProductTileCTAs;